import { volcengineModels } from './models/volcengine';
import { bytedanceModels } from './models/bytedance';
import { openaiModels } from './models/openai';
import { googleModels } from './models/google';
import { alibabaModels } from './models/alibaba';
import { klingModels } from './models/kling';
import { hailuoModels } from './models/hailuo';
import { viduModels } from './models/vidu';
import { miscModels } from './models/misc';
import { ltxModels } from './models/ltx';
import { midjourneyModels } from './models/midjourney';
import { xaiModels } from './models/xai';
import { pixverseModels } from './models/pixverse';
import { coolModels } from './models/cool';
import { volcengineInternationalModels } from './models/volcengine-international';
import { nvidiaModels } from './models/nvidia';
import { lumaModels } from './models/luma';
import { skyworkModels } from './models/skywork';
import { fluxModels } from './models/flux';
import type { TersaVideoModel, VideoModelEntry } from './types';

export type {
    VideoGenerateProps,
    VideoTaskStatus,
    VideoTaskResult,
    VideoModel,
    TersaVideoModel,
    VideoModelEntry,
} from './types';

export const videoModelList: VideoModelEntry[] = [
    ...volcengineModels,
    ...bytedanceModels,
    ...openaiModels,
    ...googleModels,
    ...alibabaModels,
    ...klingModels,
    ...hailuoModels,
    ...viduModels,
    ...miscModels,
    ...ltxModels,
    ...midjourneyModels,
    ...xaiModels,
    ...pixverseModels,
    ...coolModels,
    ...volcengineInternationalModels,
    ...nvidiaModels,
    ...lumaModels,
    ...skyworkModels,
    ...fluxModels,
];

export const videoModels: Record<string, TersaVideoModel> = Object.fromEntries(
    videoModelList.map((model) => [model.id, model])
);

/**
 * 视频功能入口使用的 tag 约定：UI（顶部工具栏等）通过这些 tag
 * 从模型注册表动态解析可用模型，新增/下线模型只需改模型配置的 tags。
 */
export const VIDEO_MODEL_TAGS = {
    /** 画质优化（视频超分） */
    upscale: 'video-upscale',
    /** 视频补帧 */
    fpsBoost: 'video-fps-boost',
    /** 视频翻译 */
    translate: 'video-translate',
    /** 水印消除 */
    watermarkRemove: 'video-watermark-remove',
    /** 字幕擦除（百度 VOD） */
    desubtitle: 'video-desubtitle',
} as const;

/** 按 tag 返回视频模型 ID 列表（保持注册表声明顺序） */
export const getVideoModelIdsByTag = (tag: string): string[] =>
    videoModelList
        .filter((m) => Array.isArray(m.tags) && m.tags.includes(tag))
        .map((m) => m.id);

/** 便于 UI：分组并按 order 排序后的模型列表 */
export const groupedVideoModels: Record<string, TersaVideoModel[]> =
    videoModelList.reduce<Record<string, TersaVideoModel[]>>((acc, entry) => {
        const groupKey = (entry as VideoModelEntry).category ?? 'Other';
        const list = acc[groupKey] ?? [];
        list.push(entry);
        acc[groupKey] = list;
        return acc;
    }, {});

Object.keys(groupedVideoModels).forEach((key) => {
    groupedVideoModels[key].sort((a, b) => {
        const ao = (a as any).order ?? 0;
        const bo = (b as any).order ?? 0;
        return ao - bo;
    });
});
